import { render } from "./PrevBtn.vue?vue&type=template&id=5070f4c1"
import script from "./PrevBtn.vue?vue&type=script&lang=js"
export * from "./PrevBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__